import { Range } from '../models/verylys';
import { PriceList, PRICING_METHOD } from '../models/verylys/priceList.model';
import { VgRange } from '../shared/components/vg-range/vg-range';

export function isSingleValue(ranges: VgRange[]): boolean {
    if (ranges?.length > 1) {
        return false;
    }

    let firstRange = ranges[0];
    if (firstRange.start == firstRange.end) {
        return true;
    }


    return false;
}

export function findRangeByValue(ranges: VgRange[], value: number): VgRange {
    if (!ranges?.length) {
        return null;
    }

    for (let range of ranges) {
        for (let i = range.start; i <= range.end; i += range.step) {
            if (i == value) {
                return range;
            }
        }
    }

    return null;
}

export function buildRangeFromPriceLists(priceLists: PriceList[]): VgRange[] {
    const values: VgRange[] = [];

    for (const priceList of priceLists) {
        const { pricing_method, quantity } = priceList.parameters;

        if (pricing_method.value === PRICING_METHOD.STATIC) {
            const value = quantity.value;
            values.push({ start: value, end: value, step: value, priceListId: priceList._id });

        } else if (pricing_method.value === PRICING_METHOD.RANGE) {
            values.push(...buildRangeFromParameters(priceList.ranges, priceList));
        }
    }

    return values;
}

export function buildRangeFromParameters(ranges: Range[], priceList?: PriceList): VgRange[] {
    return ranges
        .filter((range) => canBuildRangeFromParameters(range))
        .map(range => ({
            start: range.parameters.start.value,
            end: range.parameters.end.value,
            step: range.parameters.step.value,
            priceListId: priceList?._id
        }));
}

/** Return if value can build a range */
export function canBuildRangeFromParameters(range: Range): boolean {
    for (let key of ['start', 'end', 'step']) {
        if (range?.parameters?.[key]?.value == null) {
            return false;
        }
    }

    return true;
}

/** Build a range to an array */
export function rangesToArray(ranges: VgRange[]): number[] {
    let entries: number[] = [];

    if (!ranges?.length) {
        return [];
    }

    for (let range of ranges ?? []) {
        for (let i = range.start; i <= range.end; i += range.step) {
            entries.push(i);
        }
    }

    return entries.sort((a, b) => a - b);
}